import React from 'react';
import SvgIcon from '../SvgIcon';

/**
 * @ignore - internal component.
 */
function CalendarToday(props) {
  return (
    <SvgIcon {...props}>
      {/* <path fill="none" d="M0 0h24v24H0V0z" /> */}
      <path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z" />
    </SvgIcon>
  );
}

export default React.memo(CalendarToday);



// WEBPACK FOOTER //
// ./src/icons/internals/CalendarToday.jsx